/* HOMIRA v5 — set picker colour sync, sticky buy bar, gallery arrows, cart upsell, reveal. */
(function () {
  'use strict';

  /* ── product page: keep set links + labels in sync with the chosen colour ── */
  function syncProduct(root) {
    var want = [];
    root.querySelectorAll('[data-hm-option-index]').forEach(function (g) {
      var c = g.querySelector('input:checked');
      want.push(c ? c.value : null);
      var lbl = g.querySelector('[data-hm-option-value]');
      if (c && lbl) lbl.textContent = c.value;
    });
    root.querySelectorAll('[data-hm-set-link]').forEach(function (a) {
      var map;
      try { map = JSON.parse(a.getAttribute('data-map') || '{}'); } catch (e) { return; }
      var id = null;
      want.forEach(function (w) { if (w && map[w]) id = map[w]; });
      if (id) a.href = a.getAttribute('data-base') + '?variant=' + id;
    });
    var sc = root.querySelector('[data-hm-sticky-colour]');
    if (sc && want[0]) sc.textContent = want[0];
  }
  document.querySelectorAll('[data-hm-variants]').forEach(function (root) {
    root.addEventListener('change', function (e) { if (e.target.matches('input')) syncProduct(root); });
    syncProduct(root);

    /* sticky buy bar */
    var bar = root.querySelector('[data-hm-sticky-bar]');
    var main = root.querySelector('[data-hm-atc-button]');
    if (bar && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (past) { bar.setAttribute('data-show', ''); bar.setAttribute('aria-hidden', 'false'); }
          else { bar.removeAttribute('data-show'); bar.setAttribute('aria-hidden', 'true'); }
        });
      }).observe(main);
      var buy = bar.querySelector('[data-hm-sticky-buy]');
      if (buy) buy.addEventListener('click', function () { main.click(); });
    }
  });

  /* ── gallery arrows ── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hm-gal-step]');
    if (!b) return;
    var gal = b.closest('[data-hm-gallery]');
    if (!gal) return;
    var thumbs = gal.querySelectorAll('[data-hm-thumb]');
    if (!thumbs.length) return;
    var cur = 0;
    gal.querySelectorAll('[data-hm-main]').forEach(function (m, i) { if (m.style.display !== 'none') cur = i; });
    var next = (cur + Number(b.getAttribute('data-hm-gal-step')) + thumbs.length) % thumbs.length;
    thumbs[next].click();
  });

  /* swipe on the main image (touch) */
  document.querySelectorAll('[data-hm-gallery]').forEach(function (gal) {
    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return;
      var btn = gal.querySelector('[data-hm-gal-step="' + (dx < 0 ? '1' : '-1') + '"]');
      if (btn) btn.click();
    }, { passive: true });
  });

  /* ── cart upsell ── */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-hm-upsell-sw]');
    if (sw) {
      var box = sw.closest('[data-hm-upsell]');
      box.querySelectorAll('[data-hm-upsell-sw]').forEach(function (x) { x.classList.toggle('is-on', x === sw); });
      var add = box.querySelector('[data-hm-upsell-add]');
      if (add) add.setAttribute('data-hm-upsell-add', sw.getAttribute('data-hm-upsell-sw'));
      var img = box.querySelector('[data-hm-upsell-img]');
      if (img && sw.getAttribute('data-img')) img.src = sw.getAttribute('data-img');
      return;
    }
    var addBtn = e.target.closest('[data-hm-upsell-add]');
    if (addBtn && window.HOMIRA_add) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      window.HOMIRA_add([{ id: Number(addBtn.getAttribute('data-hm-upsell-add')), quantity: 1 }]);
    }
  });

  /* ── gentle reveal of sections below the fold (triggers early, so nothing looks empty) ── */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 20% 0px' });
    document.querySelectorAll('main .shopify-section').forEach(function (sec, i) {
      if (i === 0) return;
      var r = sec.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.2) return;
      sec.classList.add('hm-reveal');
      io.observe(sec);
    });
  }
})();
